
import SimpleLightbox from "simplelightbox";

document.addEventListener('DOMContentLoaded', () => {
	let lightbox = new SimpleLightbox('.gallery a');
}, { once: true });


